import React, { useContext, useEffect, useState } from "react";
import "./Notification.css";
import OrderCard from "../MyAccount/Account/my_account_tabs/my_orders/order_card/OrderCard";
import Common_Heading_Holder from "../Common-Component/common_heading_holder/Common_Heading_Holder";
import {
  getAllNotification,
  getNotificationCount,
  SeeNotification,
} from "../../utils/apis/myAccount/myAccount";
import { formatCustomDate } from "../../utils/common";
import { Context } from "../../utils/context";

const Notification = () => {
  const { setCountNotification, countNotification } = useContext(Context);
  const [notification, setNotification] = useState();
  const getNotification = async () => {
    const res = await getAllNotification();
    if (res?.success) {
      setNotification(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const postSeeNotification = async () => {
    const res = await SeeNotification();
    if (res?.success) {
      const res = await getNotificationCount();
      setCountNotification(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getNotification();
    postSeeNotification();
  }, []);

  return (
    <>
      <section className="Notification ">
        <div className="container">
          <Common_Heading_Holder headingText={"Notification"} />
          <div className="row">
            {notification?.map((val) => (
              <div className="col-lg-12 col-md-12">
                <OrderCard
                  data={val}
                  showViewDetails
                  title={val?.orders_detail?.product?.name}
                  footer_text_color="#E47101"
                  img="/assets/images/profile/myaccount/img1.png"
                  orderId={val?.orders_detail?.invoice_number}
                  items={val?.orders_detail?.quantity}
                  kwd={val?.orders_detail?.total_amount}
                  //   footer_text="Delivering in 10 mins"
                  date={formatCustomDate(val?.orders_detail?.createdAt)}
                
                  extraClass={"Done"}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Notification;
